import * as React from 'react';
import NumberFormat from 'react-number-format';

export interface CurrencyInputProps {
    className?: string;
    disabled?: boolean;
    id?: string;
    label?: string;
    name?: string;
    tooltip?: string;
    value: string;
    'aria-invalid'?: boolean;
    onChange(text: string): void;
}

export interface OnChangeValues {
    floatValue: number;
    formattedValue: string;
    value: string;
}

export const CurrencyInput: React.FunctionComponent<CurrencyInputProps> = (props) => {
    const { className, id, label, name, value, disabled, tooltip, onChange, 'aria-invalid': ariaInvalid } = props;

    const onValueChange = (values: OnChangeValues) => {
        onChange(values.value);
    };

    const numberFormatProps = {
        allowNegative: false,
        decimalScale: 2,
        className,
        disabled,
        id,
        label,
        name,
        prefix: '$',
        thousandSeparator: true,
        tooltip,
        type: 'text',
        value,
        'aria-invalid': ariaInvalid,
        onValueChange,
    };

    return <NumberFormat {...numberFormatProps} />;
};
